/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';

import { NotificationContext } from '.';

export function useNotification() {
  return React.useContext(NotificationContext);
}
